search-counter
  .count(class="{props.type}")
    template(if="{state.isLoading}")
      .loading-wrap
        img(src="{loadingImage}" height="72")
    template(if="{!state.isLoading}")
      template(if="{props.type == 'in_sidebar' || props.type == 'in_selectcategory' || props.type == 'in_modal'}")
        | { props.prefix }
      span(class!="{state.fetchedCount.length > 4 ? 'thin' : ''}") { state.fetchedCount }
      template(if="{props.type == 'in_sidebar' || props.type == 'in_selectcategory' || props.type == 'in_modal'}")
        | { props.suffix }
  style(type="scss").
    .count {
      &.in_sidebar {
        font-size: 14px;
        span {
          font-size: 24px;
          &.thin {
            display: inline-block;
            transform: scaleX(0.9);
          }
        }
      }
      .loading-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 45px;
        width: 45px;
      }
      &.in_modal {
        font-size: 4.6875vw;
        font-weight: 400;
        line-height: 1em;
        display: flex;
        align-items: center;
        span {
          font-size: 4.6875vw;
        }
      }
    }
  script.
    import loadingImage from 'tags/smartsearch/loading.gif'

    export default {
      loadingImage,
      onBeforeMount(props, state) {
        state.isLoading = false
        state.fetchedCount = this.formatCount(props.count)
        props.observable.on('onUpdateIsLoading', (isLoading) => {
          this.update({ isLoading })
        })
        props.observable.on('onUpdateFetchedCount', (count) => {
          const fetchedCount = this.formatCount(count)
          this.update({ fetchedCount })
        })
      },
      formatCount(count) {
        return typeof count === "string" ? count : new Intl.NumberFormat().format(count)
      },
    }
